import React, { useState, useEffect } from 'react'
import './pref.css'
import { Collapse, Select, Radio } from "antd"
import { AiOutlinePlusSquare, AiOutlineMinusSquare } from "react-icons/ai"
import { Link } from 'react-router-dom'
import { heightList, religionAndCommunityList, languageList, qualificationList, workingWithList, occupationList, incomeList } from "../../data"
import { countryAndcities } from '../../cities.js'
import { useSelector, useDispatch } from 'react-redux'
import { changePreferences } from '../../Redux/features/User/userSlice'
import { extractCastes, extractCities, extractStates } from '../../utilities/utilities'
import { useCookies } from 'react-cookie'


const { Option } = Select;
const { Panel } = Collapse;

const PartnerPreferences = () => {
  const { user } = useSelector(state => state.user)
  const dispatch = useDispatch()
  //eslint-disable-next-line
  const [cookies, setCookie, removeCookies] = useCookies(['x-auth-token'])

  const ag1 = user?.partnerPreferences?.age.split("-")[0]
  const ag2 = user?.partnerPreferences?.age.split("-")[1]
  const hi1 = user?.partnerPreferences?.height.split("-")[0]
  const hi2 = user?.partnerPreferences?.height.split("-")[1]

  const [age1, setAge1] = useState(ag1)
  const [age2, setAge2] = useState(ag2)
  const [height1, setHeight1] = useState(hi1)
  const [height2, setHeight2] = useState(hi1)
  const [religion, setReligion] = useState(user?.partnerPreferences?.religion)
  const [maritalStatus, setMaritalStatus] = useState(user?.partnerPreferences?.maritalStatus)
  const [motherTongue, setMotherTongue] = useState(user?.partnerPreferences?.motherTongue)
  const [community, setCommunity] = useState(user?.partnerPreferences?.community)
  const [countryLiving, setCountryLiving] = useState(user?.partnerPreferences?.countryLiving)
  const [stateLiving, setStateLiving] = useState(user?.partnerPreferences?.stateLiving)
  const [cityLiving, setCityLiving] = useState(user?.partnerPreferences?.cityLiving)
  const [countryGrewUpIn, setCountryGrewUpIn] = useState(user?.partnerPreferences?.grewUpIn)
  const [qualification, setQualification] = useState(user?.partnerPreferences?.qualification)
  const [workingWith, setWorkingWith] = useState(user?.partnerPreferences?.workingWith)
  const [annualIncome, setAnnualIncome] = useState(user?.partnerPreferences?.annualIncome)
  const [diet, setDiet] = useState(user?.partnerPreferences?.diet)
  const [incomeMatter, setIncomeMatter] = useState('')
  const [allCasts, setAllCasts] = useState([])
  const [allCity, setAllCity] = useState([])
  const [allStates, setAllStates] = useState([])
  const [occupation, setOccupation] = useState(user?.partnerPreferences?.occupation)
  const [smoke, setSmoke] = useState(user?.partnerPreferences?.smoke)
  const [drink, setDrink] = useState(user?.partnerPreferences?.drink)
  const [drug, setDrug] = useState(user?.partnerPreferences?.drug)
  const [bodyType, setBodyType] = useState(user?.partnerPreferences?.bodyType)
  const [residencyStatus, setResidencyStatus] = useState(user?.partnerPreferences?.residencyStatus)
  const [lookingFor, setLookingFor] = useState(user?.partnerPreferences?.lookingFor)
  const handleUpdate = () => {
    let inc;
    if (incomeMatter) {
      inc = annualIncome
    } else {
      inc = ""
    }
    let data = {
      header: cookies['x-auth-token'],
    }
    let dataa = {
      age: age1 + "-" + age2,
      height: height1 + "-" + height2,
      religion, maritalStatus, motherTongue, community, countryLiving, cityLiving,
      grewUpIn: countryGrewUpIn,
      qualification, workingWith, annualIncome: inc,
      diet: diet,
      occupation, smoke, drink, drug, bodyType, stateLiving, residencyStatus, lookingFor
    }
    dispatch(changePreferences({ ...data, ...dataa }))
  }


  useEffect(() => {
    setAllCasts(extractCastes())
    setAllCity(extractCities())
    setAllStates(extractStates())
    //eslint-disable-next-line
  }, [])

  return (
    <div className='container'>
      <div>
        <h3>Your Partner Preferences</h3>
        <h5>You will see Matches based on Preferences you have set</h5>
      </div>
      <div className='AdvancedSearch backgroundLight'>
        <div className='text-danger mb-5'><span className='fw-bold'>Note:</span> If you left the field empty that means you are open to all</div>
        <div className='row'>
          <div className="col-md-4">Looking For</div>
          <div className="col-md-8">
            <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setLookingFor(e)} defaultValue={user?.partnerPreferences?.lookingFor === "" ? "openToAll" : user?.partnerPreferences?.lookingFor}>
              <Option value="Girl Friend">Girl Friend</Option>
              <Option value="Boy Friend">Boy Friend </Option>
              <Option value="Groom">Groom</Option>
              <Option value="Bride"></Option>
            </Select>
          </div>
          <div className='listtt'></div>
          <div className="col-md-4">Age</div>
          <div className="col-md-8">
            <Select style={{ width: 100 }} onChange={(e) => setAge1(e)} defaultValue={ag1}>
              {Array.from({ length: 70 - 18 + 1 }, (_, i) => i + 18).map((age) => (
                <Option key={age} value={age}>
                  {age}
                </Option>
              ))}
            </Select>
            <span> to </span>
            <Select style={{ width: 100 }} onChange={(e) => setAge2(e)} defaultValue={ag2}>
              {Array.from({ length: 70 - 18 + 1 }, (_, i) => i + 18).map((age) => (
                <Option key={age} value={age}>
                  {age}
                </Option>
              ))}
            </Select>
          </div>
          <div className='listtt'></div>

          <div className="col-md-4">Height</div>
          <div className="col-md-8">
            <Select style={{ width: 100 }} onChange={(e) => setHeight1(e)} defaultValue={hi1}>
              {heightList.map((height, index) => (
                <Option key={index} value={height}>
                  {height}
                </Option>
              ))}
            </Select>
            <span> to </span>
            <Select style={{ width: 100 }} onChange={(e) => setHeight2(e)} defaultValue={hi2}>
              {heightList.map((height, index) => (
                <Option key={index} value={height}>
                  {height}
                </Option>
              ))}
            </Select>
          </div>
          <div className='listtt'></div>

          <div className="col-md-4">Marital Status</div>
          <div className="col-md-8">
            <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setMaritalStatus(e)} defaultValue={user?.partnerPreferences?.maritalStatus === "" ? "openToAll" : user?.partnerPreferences?.maritalStatus}>
              <Option value="Never Married">Never Married</Option>
              <Option value="Divorced">Divorced</Option>
              <Option value="Widowed">Widowed</Option>
              <Option value="Awaiting Divorce">Awaiting Divorce</Option>
              <Option value="Annulled">Annulled</Option>
            </Select>
          </div>
          <div className='listtt'></div>

          <div className="col-md-4">Body Type</div>
          <div className="col-md-8">
            <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setBodyType(e)} defaultValue={user?.partnerPreferences?.bodyType === "" ? "openToAll" : user?.partnerPreferences?.bodyType} showSearch>
              <Option value="Slim">Slim</Option>
              <Option value="Athletic">Athletic</Option>
              <Option value="Average">Average</Option>
              <Option value="slightly Over Weight">slightly Over Weight</Option>
              <Option value="Over Weight">Over Weight</Option>
            </Select>
          </div>
          <div className='listtt'></div>

          <div className="col-md-4">Religion</div>
          <div className="col-md-8">
            <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setReligion(e)} defaultValue={user?.partnerPreferences?.religion === "" ? "openToAll" : user?.partnerPreferences?.religion}>
              {
                religionAndCommunityList.map((religionAndCommunity, index) => (
                  <Option key={index} value={religionAndCommunity.religion}>{religionAndCommunity.religion}</Option>
                ))
              }
            </Select>
          </div>

          <div className='listtt'></div>

          <div className="col-md-4">Mother Tongue</div>
          <div className="col-md-8">
            <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setMotherTongue(e)} defaultValue={user?.partnerPreferences?.motherTongue === "" ? "openToAll" : user?.partnerPreferences?.motherTongue}>
              {languageList.map((language, index) => (
                <Option key={index} value={language}>
                  {language}
                </Option>
              ))}
            </Select>
          </div>


          <div className='listtt'></div>

          <div className="col-md-4">Community</div>
          <div className="col-md-8">
            <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setCommunity(e)} defaultValue={user?.partnerPreferences?.community === "" ? "openToAll" : user?.partnerPreferences?.community}>
              {
                allCasts.map((community, index) => (
                  <Option key={index} value={community}>{community}</Option>
                ))
              }
            </Select>
          </div>


          <div className='listtt'></div>

          <Collapse
            style={{ background: "transparent" }}
            bordered={false}
            expandIcon={({ isActive }) => isActive ? <AiOutlineMinusSquare size={27} /> : <AiOutlinePlusSquare size={27} />}
          >
            <Panel header="Location & Grew up in Details" key="1" style={{ marginBottom: 24, background: "#e2e2df", border: 'none' }}>
              <div className='row'>
                <div className='listtt'></div>
                <div className="col-md-4">Country Living In</div>
                <div className="col-md-8">
                  <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setCountryLiving(e)} defaultValue={user?.partnerPreferences?.countryLiving === "" ? "openToAll" : user?.partnerPreferences?.countryLiving}>
                    {countryAndcities.map((country, index) => (
                      <Option key={index} value={country.country_name}>
                        {country.country_name}
                      </Option>
                    ))}
                  </Select>
                </div>

                <div className='listtt'></div>
                <div className="col-md-4">State Living In</div>
                <div className="col-md-8">
                  <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setStateLiving(e)} defaultValue={user?.partnerPreferences?.stateLiving === "" ? "openToAll" : user?.partnerPreferences?.stateLiving}>
                    {allStates.map((state, index) => (
                      <Option key={index} value={state}>
                        {state}
                      </Option>
                    ))}
                  </Select>
                </div>


                <div className='listtt'></div>
                <div className="col-md-4">City Living</div>
                <div className="col-md-8">
                  <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setCityLiving(e)} defaultValue={user?.partnerPreferences?.cityLiving === "" ? "openToAll" : user?.partnerPreferences?.cityLiving}>
                    {allCity.map((city, index) => (
                      <Option key={index} value={city}>{city}</Option>
                    ))}
                  </Select>
                </div>
                <div className='listtt'></div>
                <div className="col-md-4">Country Grew Up In</div>
                <div className="col-md-8">
                  <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setCountryGrewUpIn(e)} defaultValue={user?.partnerPreferences?.grewUpIn === "" ? "openToAll" : user?.partnerPreferences?.grewUpIn}>
                    {countryAndcities.map((country, index) => (
                      <Option key={index} value={country.country_name}>
                        {country.country_name}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className='listtt'></div>

                <div className="col-md-4">Residency Status</div>
                <div className="col-md-8">
                  <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setResidencyStatus(e)} defaultValue={user?.partnerPreferences?.residencyStatus === "" ? "openToAll" : user?.partnerPreferences?.residencyStatus}>
                    <Option value="Citizen / Permanent Resident">Citizen / Permanent Resident</Option>
                    <Option value="Work Visa">Work Visa</Option>
                    <Option value="Student Visa">Student Visa</Option>
                    <Option value="Tourist Visa">Tourist Visa</Option>
                  </Select>
                </div>
                <div className='listtt'></div>
              </div>
            </Panel>
            <Panel header="Education & Profession Details" key="2" style={{ marginBottom: 24, background: "#e2e2df", border: 'none' }}>
              <div className='row'>
                <div className='listtt'></div>
                <div className="col-md-4">Qualification</div>
                <div className="col-md-8">
                  <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setQualification(e)} defaultValue={user?.partnerPreferences?.qualification === "" ? "openToAll" : user?.partnerPreferences?.qualification}>
                    {qualificationList.map((qualification, index) => (
                      <Option key={index} value={qualification}>
                        {qualification}
                      </Option>
                    ))}
                  </Select>
                </div>

                <div className='listtt'></div>
                <div className="col-md-4">Working With</div>
                <div className="col-md-8">
                  <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setWorkingWith(e)} defaultValue={user?.partnerPreferences?.workingWith === "" ? "openToAll" : user?.partnerPreferences?.workingWith}>
                    {workingWithList.map((workingWith, index) => (
                      <Option key={index} value={workingWith}>
                        {workingWith}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className='listtt'></div>
                <div className="col-md-4">Occupation</div>
                <div className="col-md-8">
                  <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setOccupation(e)} defaultValue={user?.partnerPreferences?.occupation === "" ? "openToAll" : user?.partnerPreferences?.occupation}>
                    {occupationList.map((occupation, index) => (
                      <Option key={index} value={occupation}>
                        {occupation}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className='listtt'></div>
                <div className="col-md-4">Annual Income</div>
                <div className="col-md-8">
                  <Radio.Group onChange={(e) => setIncomeMatter(e.target.value)} defaultValue={user?.partnerPreferences?.annualIncome === "" && false}>
                    <Radio value={false}>Doesn't matter</Radio>
                    <Radio value={true}>Set an Income Range</Radio>
                  </Radio.Group>
                  {incomeMatter === true && (
                    <Select style={{ width: 600 }} onChange={(e) => setAnnualIncome(e)} defaultValue={user?.partnerPreferences?.annualIncome !== "" && user?.partnerPreferences?.annualIncome}>
                      {incomeList.map((income, index) => (
                        <Option key={index} value={income}>
                          {income}
                        </Option>
                      ))}
                    </Select>
                  )}
                </div>
              </div>
            </Panel>
            <Panel header="Lifestyle & Appearance" key="3" style={{ marginBottom: 24, background: "#e2e2df", border: 'none' }}>
              <div className='row'>
                <div className='listtt'></div>
                <div className="col-md-4">Diet</div>
                <div className="col-md-8">
                  <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setDiet(e)} defaultValue={user?.partnerPreferences?.diet === "" ? "openToAll" : user?.partnerPreferences?.diet}>
                    <Option value="Veg">Veg</Option>
                    <Option value="Non-Veg">Non-Veg</Option>
                    <Option value="Occasionally Veg">Occasionally Veg</Option>
                    <Option value="Occasionally Non-Veg">Occasionally Non-Veg</Option>
                    <Option value="Vegetarian">Vegetarian</Option>
                    <Option value="Non-Vegetarian">Non-Vegetarian</Option>
                    <Option value="Eggetarian">Eggetarian</Option>
                    <Option value="Vegan">Vegan</Option>
                  </Select>
                </div>

                <div className='listtt'></div>
                <div className="col-md-4">Do You smoke.?</div>
                <div className="col-md-8">
                  <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setSmoke(e)} defaultValue={user?.partnerPreferences?.smoke === "" ? "openToAll" : user?.partnerPreferences?.smoke}>
                    <Option value="Yes">Yes</Option>
                    <Option value="No">No</Option>
                    <Option value="Occasionally">Occasionally</Option>
                  </Select>
                </div>
                <div className='listtt'></div>
                <div className="col-md-4">Do You Drink.?</div>
                <div className="col-md-8">
                  <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setDrink(e)} defaultValue={user?.partnerPreferences?.drink === "" ? "openToAll" : user?.partnerPreferences?.drink}>
                    <Option value="Yes">Yes</Option>
                    <Option value="No">No</Option>
                    <Option value="Occasionally">Occasionally</Option>
                  </Select>

                </div><div className='listtt'></div>
                <div className="col-md-4">Do You take Drugs.?</div>
                <div className="col-md-8">
                  <Select mode="multiple" style={{ width: 600 }} onChange={(e) => setDrug(e)} defaultValue={user?.partnerPreferences?.drug === "" ? "openToAll" : user?.partnerPreferences?.drug}>
                    <Option value="Yes">Yes</Option>
                    <Option value="No">No</Option>
                    <Option value="Occasionally">Occasionally</Option>
                  </Select>
                </div>
              </div>
            </Panel>
          </Collapse>

          <div className='d-flex justify-content-center'>
            <Link className='btn btn-outline-warning customBtn' onClick={handleUpdate}>
              Update
            </Link>
            {/* <Link className='mt-2' style={{ marginLeft: 10 }}>Reset</Link> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PartnerPreferences
